import React, {Fragment, PureComponent} from 'react';

import Picture from '../Picture/Picture.jsx';
import withManagers from '../../HOC/withManagers.jsx';

import './ManagersPresentation.scss';
import logo from '../../../public/static/logos/linkedin_logo.png';

class ManagersPresentation extends PureComponent {
  renderManager = (manager) => {
    return <Fragment>
      <div className="box">
        <Picture
          src={manager?.image ?? null}
          alt={manager.fullname}
          className="picture mx-3"
        />
        {manager.linkedin_url && <img src={logo} alt="Logo" className="logo mx-6"/>}
        <div className="manager-presentation-infos">
          <h6 className="name">{manager.fullname}</h6>
        </div>
      </div>
    </Fragment>;
  }

  render() {
    return <div className="managers-presentation row justify-content-center mb-5">
      {this.props.managers.map((manager) => (
        <div key={manager.id} className="d-flex flex-column align-items-center manager-presentation mb-4">
          {manager.linkedin_url ?
            <a href={manager.linkedin_url} target="_blank" rel="noreferrer noopener">
              {this.renderManager(manager)}
            </a> : this.renderManager(manager)
          }
        </div>
      ))}
    </div>;
  }
}

export default withManagers(ManagersPresentation);